// Google Login

import { GoogleLoginResponse } from "../types/api";
import axiosPublicInstance from "../utils/refreshApi";

// Функція для запиту
export const googleLogin = async (
  googleToken: string
): Promise<GoogleLoginResponse | undefined> => {
  try {
    const response = await axiosPublicInstance.post("api/users/social-login/", {
      provider: "google-oauth2",
      access_token: googleToken,
    });

    return response.data;
  } catch (error) {
    console.error("Error in Google flow:", error);
    return undefined;
  }
};
